window.$ = window.jQuery = require('jquery');

require('@babel/polyfill');

//require('popper.js/dist/popper.min');
import 'bootstrap';

require('jquery-nice-select/js/jquery.nice-select');
require('vgnav/dist/js/vgnav');
require('owl.carousel/dist/owl.carousel');
require('vgformsender/dist/js/vgformsender.min');

require('../../vendor/fancybox/jquery.fancybox');
require('../../vendor/slick/slick.min');
require('../../vendor/vegas/scrollTo/jquery.vegasScrollTo');

require('./functions');

require('./modules/catalog/images');
require('./modules/owl');
require('./modules/coverage');
require('./modules/vegas');
require('./modules/ym');


require('./modules/cart');
require('./modules/product');
// [[vegas]]


require('./custom');
